import * as firebase from "firebase/app";
import Vue from "vue";
import VueApexCharts from "vue-apexcharts";
import VueTimeago from "vue-timeago";
import WinfaktVueComponents, { IWinfaktVueComponentsOptions } from "winfakt-vue-components";
import App from "./App.vue";
import router from "./router";
import "./utils/vue-filters";
import VueCodeMirror from "vue-codemirror";
import "codemirror/lib/codemirror.css";
import "codemirror/theme/base16-dark.css";
import { fab } from "@fortawesome/free-brands-svg-icons";

Vue.use(WinfaktVueComponents, {
	defaultDatatableCompare: (a: any, b: any) => a.id == b.id,
	iconFonts: [fab],
} as IWinfaktVueComponentsOptions);
Vue.config.productionTip = false;


Vue.use(VueApexCharts);
Vue.component("Apexchart", VueApexCharts);
Vue.use(VueCodeMirror, {
	options: {
		theme: "base16-dark",
		tabSize: 4,
		lineNumbers: true
	}
});


Vue.use(VueTimeago, {
	name: "app-timeago",
});

import "@/assets/css/style.css";
import "@/assets/css/style.scss";

var config = {
	apiKey: "AIzaSyDTbn9QN9IxPnfmCtSqkNu2RRBWnMiFCfs",
	authDomain: "authentication-test-proj-3570d.firebaseapp.com",
	databaseURL: "https://authentication-test-proj-3570d.firebaseio.com",
	projectId: "authentication-test-proj-3570d",
	storageBucket: "authentication-test-proj-3570d.appspot.com",
	messagingSenderId: "118183658140",
	clientId: "118183658140-h36bkh331dbb7ksn1ifidotq8pu3q7nn.apps.googleusercontent.com",
	scopes: [
		"email",
		"profile"
	]
};
firebase.initializeApp(config);

new Vue({
	router,
	render: h => h(App)
}).$mount("#app");

if (process.env.NODE_ENV == "development") {
	window.addEventListener("keydown", (e: KeyboardEvent) => {
		if (e.keyCode == 123) {
			debugger;
		}
	});
}

if (localStorage.getItem("theme") != null) {
	if (localStorage.getItem("theme") == "pink") {
		window.document.body.classList.add("pink");
	}
}
window.addEventListener("keydown", function(e: KeyboardEvent) {
	if (e.key == "F1" &&e.altKey){
		if (window.document.body.classList.contains("pink")){
			window.document.body.classList.remove("pink");
			localStorage.setItem("theme", "");
		}else{
			window.document.body.classList.add("pink");
			localStorage.setItem("theme", "pink");
		}
		return;
	}
});
